<template>
    <editor
        v-model="text"
        :api-key="editorApi"
        :init="editorInit"
        :disabled="disabled"
    /> 
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
export default {
    name : "TextEditor",
    props: {
        value : {
            type: String, 
            required : false,
            default: ""
        },
        editorInit: {
            type: Object, 
            required: false, 
            default: function() {
                return {
                    height: 150,
                    menubar: false,
                    plugins: ['lists', 'paste'],
                    toolbar:
                    'formatselect | bold italic underline| \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | superscript subscript | paste',
                    paste_as_text: true,
                    setup: function(editor) {
                        editor.on('PostProcess', function(ed) {
                            ed.content = ed.content.replace(/(<p>)/gi,'<span>').replace(/(<\/p>)/gi,'<\/span>');
                        });
                    }
                }
            }
        },
        disabled: {
            type: Boolean, 
            required: false,
            default : false
        }
    },
    components: {
        Editor
    },
    data: function() {
        return {
            editorApi : "vjwto0uux6l25qp5q562n4506qp5s5s615aruwxt2x4m5mt5"
        }
    }, 
    computed: {
        text: {
            get: function() {
                if(this.value) {
                    return this.value;
                }
                return "";
            },
            set: function(newVal) {
                this.$emit('updateText', newVal);
            }
        },
    }
}
</script>

<style>

</style>